export default __webpack_public_path__ + "static/media/meslay8.2bf942bb.jpg";